import { useEffect } from 'react';

import { useTheme } from '@emotion/react';
import { useBaseCohorts } from 'components/Views/Hooks/dataHooks';
import { useParsedCohortQueryParam } from 'components/hooks/useParsedCohortQueryParam';
import { useDispatch } from 'react-redux';
import { setBaseCohort, useCheckedBaseCohort, useViewsPanelState } from 'reducers/viewsSlice';

import { Divider } from 'uiToolkitV1/Divider';
import { ListRadio } from 'uiToolkitV1/ListRadio';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

import { PerformanceFilterWarning } from './PerformanceFilterWarning';

const BaseCohortSubtitleMap = {
  '-1': 'This selects all the people in the organization',
  '-2': 'This includes all the employees who directly report to you.',
  '-3': 'This includes all the employees who directly or indirectly report to you.',
};

const getBaseCohorts = (cohortList) =>
  [...cohortList]
    // .filter((cohort) => [-1, -2, -3, -4, -5, -6, -7, -8, -9, -10].includes(cohort.id))
    .sort((a, b) => b.id - a.id)
    .map((cohort) => ({ ...cohort, uuid: String(cohort.id) }));

export const BaseCohort = () => {
  // const {
  //   data: { defaultList } = {},
  //   isLoading,
  //   isSuccess
  // } = useSidebarCohortViews(useSidebarNavMatchRoute());
  const checkedBaseCohort = useCheckedBaseCohort();
  const queryCohort = useParsedCohortQueryParam();
  const { constraints = {} } = useViewsPanelState();

  // const baseCohorts = getBaseCohorts(defaultList ?? []);
  const { data: baseCohorts, isLoading, isSuccess } = useBaseCohorts();
  // todo: vikalp check this when views work
  const constraintFilteredBaseCohort = constraints?.allowOnlyMyCompany
    ? baseCohorts?.filter((cohort) => cohort.id === -1)
    : baseCohorts;

  const dispatch = useDispatch();
  const theme = useTheme();

  useEffect(() => {
    if (checkedBaseCohort.uuid !== null) {
      return;
    }
    if (isSuccess) {
      // preselect base cohort if createView is clicked from existing base cohort pages like My Team, My Organization etc
      const cohortId = queryCohort?.id;
      const cohortIdExists = constraintFilteredBaseCohort.some((c) => c.id === cohortId);
      dispatch(setBaseCohort(cohortIdExists ? String(cohortId) : constraintFilteredBaseCohort[0].uuid));
    }
  }, [constraintFilteredBaseCohort, checkedBaseCohort.uuid, isSuccess, queryCohort]);

  if (isLoading) {
    return (
      <SkeletonLoader
        skeletons={['50px']}
        startColor={theme.colors.button.blue.default}
        endColor={theme.colors.button.blue.disabled}
      />
    );
  }

  return (
    <>
      <PerformanceFilterWarning>
        Create a custom view by selecting a base set, then add conditions using the filters on the left panel
      </PerformanceFilterWarning>
      {constraintFilteredBaseCohort?.map((baseCohort) => {
        const isChecked = baseCohort.uuid === checkedBaseCohort.uuid;

        return (
          <>
            <ListRadio
              checked={isChecked}
              label={baseCohort.name}
              subText={BaseCohortSubtitleMap[baseCohort.uuid]}
              onClick={() => dispatch(setBaseCohort(baseCohort.uuid))}
            />
            <Divider borderColor={theme.colors.neutral.CFD7DF} />
          </>
        );
      })}
    </>
  );
};
